import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {
  I2faResponseCode,
  ILoginCustomization,
  SessionService,
} from 'pod-ng-core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { finalize, pluck } from 'rxjs/operators';
import { AppConfigService } from 'src/services/app-config.service';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
})
export class LoginFormComponent implements OnInit {
  public environment = environment;
  private oLoginCustomization: Observable<ILoginCustomization>;
  public loginCustomization: ILoginCustomization;

  public model: any;
  public submitting = false;
  public error: string | boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public appConfig: AppConfigService,
    private session: SessionService
  ) {
    this.oLoginCustomization = activatedRoute.data.pipe(
      pluck('loginCustomization')
    );
    if (this.oLoginCustomization) {
      this.oLoginCustomization.subscribe(
        data => (this.loginCustomization = data)
      );
    }
  }

  ngOnInit() {
    this.model = {};
  }

  login(form: NgForm) {
    if (form.valid) {
      this.submitting = true;
      this.error = null;

      this.session
        .login(this.model.username, this.model.password)
        .pipe(finalize(() => (this.submitting = false)))
        .subscribe(
          result => {
            const returnUrl =
              this.activatedRoute.snapshot.queryParams['returnUrl'] || '/';

            switch (result.code) {
              case 'logged':
                this.router.navigate([returnUrl]);
                break;
              case I2faResponseCode.TWOFA_SET:
              case I2faResponseCode.TWOFA_CONFIRM:
                this.router.navigate(
                  ['/login', result.code, result.type, result.token],
                  {
                    queryParams: {
                      returnUrl,
                    },
                  }
                );
                break;
              default:
                this.error = 'Next action not available.';
                break;
            }
          },
          error => {
            this.error =
              error?.error?.message || 'Username or password are incorrect.';
          }
        );
    }
  }
}
